// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module__layout___HqdjW"};